import { Button } from "components/universal/button";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import cls from './bottom-bar.module.scss';
import { PATHS } from "constants/routes";

type BottomBarProps = {
    back?: string | null;
    next?: string | null;
    isAvaible: boolean;
    isQuiz: boolean | null;
    isSuccessSendAnswer: boolean;
};

export const BottomBar = ({ back, next, isAvaible, isQuiz, isSuccessSendAnswer }: BottomBarProps) => {
    const { t } = useTranslation();
    
    return (
        <div className={`${cls.wrapper} ${!back ? cls.buttonEnt : ''}`}>
            <div className={cls.container}>
                {back ? (
                    <Link to={back} className={cls.buttonBack}>
                        <Button styleType="border">
                            {t('home.quiz.prev-capital-letter')}
                        </Button>
                    </Link>
                ): 
                    <div className={cls.empty}>empty</div>
                }

                {(next || isSuccessSendAnswer) ? (
                    <Link to={isQuiz ? PATHS.HAND_HYGIENE : next} className={cls.buttonNext}>
                        <Button disabled={!isAvaible}>
                            {isQuiz ? t('home.quiz.finish-quiz') : t('home.quiz.next-capital-letter')}
                        </Button>
                    </Link>
                ) : (
                    <Button disabled>
                        {isQuiz ? t('home.quiz.finish-quiz') : t('home.quiz.next-capital-letter')}
                    </Button>
                )}
            </div>
        </div>
    );
};
